module.exports = __webpack_public_path__ + "src/assets/img/share/tips/extroversion/a44dbef12c9dd9fa986d3f91c55917b5.png";